<style lang="scss" scoped>
.info {
  width: 270px;
}

.video {
  width: 340px;
}

.el-step__description {
  > div {
    background: #f9f9f9;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
  }

  &.is-success {
    > div {
      background: rgba(8, 147, 255, 0.06);
      border: 1px solid #0893ff;
      border-radius: 4px;
    }
  }
}

.btn {
  border: 1px solid #dcdfe6;
  border-radius: 2px;
  line-height: 30px;

  &.isCurr {
    color: #3692f9;
    background: #e6f1fc;
    border: 1px solid #a3d0fd;
    border-radius: 2px;
  }
}
</style>
<template>
  <div class="flex">
    <div class="main flex1 flex column oh" :style="heightStyle">
      <el-card class="flex0">
        <jijiu-page-title title="转诊动态" prefix="">
          <span class="color_777 ml10 fs12"
          >编号：{{ info.emergencyyReferralOrderNo }}</span
          >
        </jijiu-page-title>
        <div class="fs14 mt5 flex">
          <span class="color_333"
          >{{ info.patName }} {{ info.patGender | sexFilter }}
            {{ info.patAge }}岁</span
          >
          <span class="color_main ml10 flex1">{{ info.initHosName }} → {{ info.hopeHosName }}</span>
          <span class="color_main">{{ info.referralStatusDesc }}</span>
        </div>
        <div class="mt15">
          <el-steps :active="steps.length" finish-status="success" align-center>
            <el-step
                :title="item.name"
                v-for="(item, index) in liucheng"
                :key="index"
                :status="item.status"
            >
              <div slot="description">
                <p class="fs12 color_777">
                  {{ item.createTime | timeFilter("YYYY-MM-DD HH:mm") }}
                </p>
                <p class="" v-html="item.procedureDescribtion"></p>
              </div>
            </el-step>
          </el-steps>
        </div>
      </el-card>
      <el-card class="mt15 flex1" style="overflow-y: auto" ref="main">
        <jijiu-page-title title="患者档案" prefix="">
          <div class="flex1 fs12" style="text-align: right">
            <span class="color_777">运送费用：</span>
            <span class="color_orange">￥{{ info.paymentAmount || "0" }}</span>
          </div>
        </jijiu-page-title>
        <div class="flex mt10">
          <div
              class="btn pointer fs14 pl10 pr10 mr10"
              @click="currIdx = idx"
              v-for="(btn, idx) in btnGroup"
              :key="idx"
              :class="{ isCurr: idx === currIdx }"
          >
            {{ btn.name }}
          </div>
        </div>
        <div class="panelGroup mt15">
          <base-form
              @modify="modify"
              :query="query"
              v-if="currName === '病情资料'"
              :info="info"
          ></base-form>
          <zc-table key="zc" v-if="currName === '出院交接单'" :id="id" :data="info" :query="query"
                    @add="()=>addInOut('out')"
                    @edit="(id)=>addInOut('out',id)"></zc-table>
          <pg-table v-if="currName==='患者评估'" @add="$refs.addPg.show()" :id="id"
                    @edit="(id)=>$refs.addPg.show(id)"></pg-table>
          <record-form v-if="currName === '急救日志'" :id="id"></record-form>
          <nodata-for-detail title="暂未对接救医疗设备" v-if="currName==='生命体征'">
            <p class="fs14 jcc mt5 flex">您可前往<span class="color_main pointer"
                                                       @click="toTab('急救日志')">急救日志</span>手动上传患者生命体征
            </p>
          </nodata-for-detail>
          <zr-table key="zr" v-if="currName === '入院交接单'" :id="id" :data="info" :query="query"
                    @add="()=>addInOut('in')"
                    @edit="(id)=>addInOut('in',id)"></zr-table>
          <pj-table v-if="currName === '转诊评价'" :id="id"></pj-table>
        </div>
      </el-card>
    </div>
    <jijiu-detail-info
        :info="info"
        :aspect-user="query.aspectUser"
    ></jijiu-detail-info>
    <add-dialog ref="add"></add-dialog>
    <in-out-form-dialog ref="inout" :info="info"></in-out-form-dialog>
    <add-pg-form-dialog ref="addPg" :info="info"></add-pg-form-dialog>
  </div>
</template>
<script>
import {ContentWidthMixin} from "@/common/lib/mixins/contentWidth";
import JijiuPageTitle from "../components/jijiu-page-title";
import JijiuDetailInfo from "../components/jijiu-detail-info";
import BaseForm from "../components/base-form";
import RecordForm from "../components/record-form";
import {staffService} from "../service/staff";
import {sexFilter, timeFilter} from "@/common/lib/filters";
import {
  ASPECTUSER,
  EXAMINE_HANDLE, GO_TO_HOSPITAL,
  handlerProcedureDescribtion,
  NEED_ARRANGE,
  NEED_ISSUE,
  STAFF_PROCEDURE_STATUS
} from "../config";
import ZcTable from "../../form/components/zc-table";
import ZrTable from "../../form/components/zr-table";
import {STAFF_ADD_ORDER_SUCCESS, STAFF_ADD_PG, STAFF_EDIT_PG, STAFF_PROCESS_ORDER_SUCCESS} from "../events";
import AddDialog from "../components/add-dialog";
import PjTable from "../../form/components/pj-table";
import {isEmpty, queryHasEmergencyReferral} from "@/common/lib/utils";
import {hushiMixin} from "@/common/lib/mixins/hushi";
import NodataForDetail from "../components/nodata-for-detail";
import InOutFormDialog from '../components/in-out-form'
import {callHushiActionCache} from "@/common/lib/cache/callHushiAction";
import PgTable from "@/modules/form/components/pg-table";
import AddPgFormDialog from "@/modules/staff/components/add-pg-form-dialog";
import * as R from 'ramda';


export default {
  name: "jijiu-detail",
  filters: {sexFilter, timeFilter},
  components: {
    AddPgFormDialog,
    PgTable,
    InOutFormDialog,
    NodataForDetail,
    PjTable,
    AddDialog,
    ZrTable,
    ZcTable,
    RecordForm,
    BaseForm,
    JijiuDetailInfo,
    JijiuPageTitle
  },
  mixins: [ContentWidthMixin, hushiMixin],
  data() {
    const btnArr = [
      "病情资料",
      "出院交接单",
      "患者评估",
      "急救日志",
      "生命体征",
      "入院交接单",
      "转诊评价"
    ];
    const makeBtnGroup = arr => {
      return [...arr].map(r => ({
        name: r
      }));
    };
    return {
      id: "",
      currIdx: 0,
      _timer: null,
      info: {},
      query: {},
      btnGroup: makeBtnGroup(btnArr)
    };
  },
  computed: {
    isAccept() { // 是接收者
      return ASPECTUSER.accept === this.query.aspectUser
    },
    isNotEmergencyReferral() { // 不是急救转诊
      return this.info.consultId || !queryHasEmergencyReferral(this.$route.query)
    },
    currName() {
      return this.btnGroup[this.currIdx].name;
    },
    showHzpg() {
      let val = this.info.dispatchingCarType || this.info.hopeDispatchingCarType;
      if (val === 'SUPERIOR_HOSPITAL_HELICOPTER') return true
      return false;
    },
    heightStyle() {
      return {
        height: `${window.innerHeight - 60 - 30}px`
      }
    },
    steps() {
      return this.info.emergencyProcedureRecordsList || [];
    },
    liucheng() {
      const {referralStatus} = this.info;
      const list = this.steps;
      const data = R.clone(STAFF_PROCEDURE_STATUS);
      return data.map(r => {
        r._id = r.id;
        const item = list.find(rr => rr.proceduceStatus === r.id) || {};
        const {proceduceStatus} = item;
        const status = (() => {// 部分状态单独处理
          if (referralStatus === "CANCEL" && proceduceStatus === EXAMINE_HANDLE.id) return 'error';
          if (proceduceStatus === GO_TO_HOSPITAL.id) return 'success';
          return null;
        })()

        if (this.isAccept && this.isNotEmergencyReferral) { // 会诊转诊 - 接收者
          if (referralStatus === NEED_ARRANGE) { // 待安排
            if (proceduceStatus === NEED_ISSUE.id) {
              item.name = '已审核';
              item.procedureDescribtion = '[审核通过]';
            }
            if (proceduceStatus === EXAMINE_HANDLE.id) {
              item.name = '待处理';
              item.procedureDescribtion = '审核通过后，等待上级医院安排处理';
            }
          }
        }


        if (item.procedureDescribtion) {
          item.procedureDescribtion = handlerProcedureDescribtion(item.procedureDescribtion, status);
        } else {
          item.procedureDescribtion = `<span class="color_777">等待${r.name}</span>`;
        }
        return {
          ...r, ...item,
          status
        };
      });
    }
  },
  async created() {
    bus.$on(STAFF_ADD_ORDER_SUCCESS.id, this.backList);
    bus.$on(STAFF_PROCESS_ORDER_SUCCESS.id, this.getDetail);
    bus.$on(STAFF_EDIT_PG.id, this.scrollToTop)
    bus.$on(STAFF_ADD_PG.id, this.scrollToTop)

    this.id = this.$route.query.id;
    this.query = this.$route.query;
    await this.getDetail();
    await this.intoVideo();
    this.$nextTick(() => {
      if (!this.showHzpg) {
        this.btnGroup.splice(2, 1);
      }
    })
  },
  beforeDestroy() {
    this.clear();
    bus.$off(STAFF_ADD_ORDER_SUCCESS.id, this.backList);
    bus.$off(STAFF_PROCESS_ORDER_SUCCESS.id, this.getDetail);
    bus.$off(STAFF_EDIT_PG.id, this.scrollToTop)
    bus.$off(STAFF_ADD_PG.id, this.scrollToTop)
  },
  watch: {
    $route(newV) {
      this.id = newV.query.id;
      this.query = newV.query;
      this.getDetail();
      this.intoVideo();
    }
  },
  methods: {
    toTab(name) {
      let idx = this.btnGroup.findIndex(r => r.name === name);
      idx >= 0 && (this.currIdx = idx);
    },
    scrollToTop() {
      this.$refs.main.$el.scrollTop = 0;
    },
    clear() {
      if (this._timer) {
        clearTimeout(this._timer)
        this._timer = null
      }
    },
    addInOut(type, id) {
      this.$refs.inout.show(type, id);
    },
    async intoVideo() {
      let canCallHushi = callHushiActionCache.get();
      if (canCallHushi) {
        const obj = await staffService.intoVideo(this.id);
        !isEmpty(obj) &&
        this.callV2({
          ...obj,
          userId: this.loginInfo.id,
          userName: this.loginInfo.staffName
        })
        /*this.call({
          ...obj,
          UID: obj.uid
        });*/
        callHushiActionCache.set(null);
      }
    },

    modify() {
      this.$refs.add.show(this.info, 'edit');
    },
    backList() {
      this.$router.push(this.isNotEmergencyReferral ? '/staff/consult/faqi' : "/staff/faqi");
    },
    async getDetail() {
      this.info = await staffService.detailOrder(this.id);
      this.$store.commit('staff/setOrderInfo', this.info);
      this.clear();
      this._timer = setTimeout(() => {
        this.getDetail();
      }, 10000)
    },
    async getLiucheng() {
      await staffService.liuchengOrder({
        orderId: this.id,
        procedureStatus: "ISSUE"
      });
    }
  }
};
</script>
